export const DYNAMIC_COPY = {
  400: {
    title: 'We’re sorry about this',
    message:
      'The app is having some issues fulfilling this request. Our team will get to work on resolving the issue. Please try again later.',
    primaryCta: 'OK',
  },
  408: {
    title: 'Timed out',
    message:
      'We’re sorry, but this request has exceeded the max time to process. Tap below to return to the previous screen, or try again.',
    primaryCta: 'Try again',
    secondaryCta: 'Go back',
  },
  429: {
    title: 'Limit reached',
    message:
      'We’re sorry, but you’ve reached the limit on attempted requests for this action. These limits are put in place for security purposes. Please try again later.',
    primaryCta: 'OK',
  },
  500: {
    message:
      'The server is having a hard time fulfilling our request. Tap below to return to the previous screen, or try again.',
    title: 'Please try again',
    primaryCta: 'Try again',
    secondaryCta: 'Go back',
  },
  504: {
    title: 'Timed out',
    message:
      'We’re sorry, but this request has exceeded the max time to process. Tap below to return to the previous screen, or try again.',
    primaryCta: 'Try again',
    secondaryCta: 'Go back',
  },
  networkError: {
    title: 'We can’t connect to the internet',
    message:
      'We’re sorry, but we’re unable to get a connection. Tap below to return to the previous screen, or if you have a better signal, please try again.',
    primaryCta: 'Retry',
    secondaryCta: 'Go back',
  },
}
